<template>
    <base-spinner v-if="isLoading"></base-spinner>
    <div v-else class="main">
        <div class="block">
            <div v-if="!!error" class="notification is-danger">
                <p>{{ error }}</p>
            </div>
            <FDItem v-for="fd in fdList" :key="fd.id" :id="fd.id" :date="fd.date" :sponsor="fd.sponsor">FD Item</FDItem>
        </div>
        <div class="block">
            <router-link to="/fd/create">
                <button class="button is-large is-light is-info is-rounded is-fullwidth">Create a New FD</button>
            </router-link>
        </div>
        <div class="block">
            <button v-if="!pastFDList" class="button is-large is-light is-info is-rounded is-fullwidth"
                @click="loadPastFDs">Load Past FDs</button>
            <template v-else>
                <h1 class="title align-center is-4">Past FDs</h1>
                <FDItem v-for="fd in pastFDList" :key="fd.id" :id="fd.id" :date="fd.date" :sponsor="fd.sponsor" :pastFD="true" />
                <button v-if="hasMorePastFDs" class="button is-large is-light is-info is-rounded is-fullwidth"
                    @click="loadPastFDs">Load More Past FDs</button>
                <p v-else class="has-text-centered has-text-grey-light is-size-6">All past FDs loaded</p>
            </template>
        </div>
    </div>
</template>

<script>
import FDItem from '@/components/fd/FDItem.vue';

export default {
    components: {
        FDItem
    },
    data() {
        return {
            isLoading: false,
            error: null,
        }
    },
    computed: {
        fdList() {
            return this.$store.getters['fd/getFDs'];
        },
        pastFDList() {
            return this.$store.getters['fd/getPastFDs'];
        },
        hasMorePastFDs() {
            return this.$store.getters['fd/hasMorePastFDs'];
        }
    },
    created() {
        this.loadFDs();
    },
    methods: {
        async loadFDs() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('fd/fetchFDs');
            } catch (error) {
                this.error = error.message || 'Something failed!';
            }
            this.isLoading = false;
        },
        async loadPastFDs() {
            this.isLoading = true;
            try {
                await this.$store.dispatch('fd/fetchPastFDs');
            } catch (error) {
                this.error = error.message || 'Something failed!';
            }
            this.isLoading = false;
        },
        handleError() {
            this.error = null;
        },
    },
};
</script>